// @ts-nocheck
import { clearfixStyles, stretchStyles } from "@toolkit/Themes/common/mixins/common";
import { css } from "styled-components";

export const pageStyles = () => {
    return css`
        & {
            overflow: visible; /* Required to override overflow media queries */
        }

        ${clearfixStyles()}

        &:is(main) {
            ${stretchStyles()}
        }
    `;
};

export const pageOverflowStyles = () => {
    return css`
        ${pageStyles()};

        && {
            /* Required to override overflow media queries */
            overflow-y: visible;
            overflow-x: hidden;
        }
    `;
};
